import { environmentDefaults } from './environment-defaults';
import { API_ENDPOINTS } from './api-endpoints';
import * as defaultsDeep from 'lodash.defaultsdeep';

const featureFlags = {
  OCA_SUBMITTED: true,
  PLATE_TRANSFER: false,
  PLATE_TRANSFER_NEW_UI: true,
  SIMULATE_PAYMENTS: true,
  NEW_VEHICLE: true,
  SHARE_OCA: true,
  LOG: true,
  CHAT: true,
  MSD: true,
  SIGNAL: true,
  SECURITYDEPOSITE_UI : true,
  TOTALOFPAYMENTS_UI: true,
  CARS_DEALER_UI: true,
  DEALER_FUNDED: true,
  TRADE_SIGNAL: true,
  TRADE_TAX_SAVINGS:true,
  PAYMENT_STREAM :true,
  PAYMENT_STREAM_FINANCE_CASH :false,
  QR_CODE:true,
  DAYS_TO_FIRST:true,
  PREVIOUS_RENTAL: true,
  SET_DEALER_CASH: true,
  ISPRESOLD_ENABLED: true,
  RELEASE_NOTES: true,
  DUPLICATE_CASHDOWN: true,
  RESIDUAL_PERCENTAGE: true,
  CONFIGURABLE_PRICING_PDF: true,
  ENABLE_TFMV: false, // Texas Fair Market Value Deduction (TFMV)
  SECURITY_DEPOSIT: true,
  NEXUS_TOYOTA_DOMAIN: true,
}

const override = {
  DESKING: API_ENDPOINTS.DESKING.STAGE,
  hostname: API_ENDPOINTS.HOSTNAME.STAGE,
  production: API_ENDPOINTS.ISPRODUCTION.STAGE,
  //AOT: AOT,
  ENV: API_ENDPOINTS.ENV.STAGE, //(PROD || TEST || QA || STAGE || STAGE) ? JSON.stringify('production') : JSON.stringify('development'), 
  /**
  * specifies which @ngrx dev tools will be available when you build and load
  * your app in dev mode. Options are: monitor | logger | both | none
  */
  STORE_DEV_TOOLS: API_ENDPOINTS.STORE_DEV_TOOLS.STAGE,
  MIN_LOG_LEVEL: API_ENDPOINTS.MIN_LOG_LEVEL.STAGE,
  ACTUAL_ENV: API_ENDPOINTS.ACTUAL_ENV.STAGE,  //  PROD ? JSON.stringify('production') : QA ? JSON.stringify('qa') : TEST ? JSON.stringify('test') : STAGE ? JSON.stringify('STAGE') : STAGE ? JSON.stringify('stage') : JSON.stringify('development'),
  EFC_URL: API_ENDPOINTS.EFC_URL.STAGE,
  AUTH_BASE_URL: API_ENDPOINTS.AUTH_BASE_URL.STAGE,
  DIS_URL: API_ENDPOINTS.DIS_URL.STAGE,
  BASE_SERVICE_URL: API_ENDPOINTS.BASE_SERVICE_URL.STAGE,
  PRESOLD_BASE_SERVICE_URL: API_ENDPOINTS.PRESOLD_BASE_SERVICE_URL.STAGE,
  USED_VEHICLE_BASE_SERVICE_URL: API_ENDPOINTS.USED_VEHICLE_BASE_SERVICE_URL.STAGE,
  POST_LOGOUT_REDIRECT_URL: API_ENDPOINTS.POST_LOGOUT_REDIRECT_URL.STAGE,
  SILENT_REDIRECT_URL: API_ENDPOINTS.SILENT_REDIRECT_URL.STAGE,
  AUTHORIZATION_ENDPOINT: API_ENDPOINTS.AUTHORIZATION_ENDPOINT.STAGE,
  ISSUER: API_ENDPOINTS.ISSUER.STAGE,
  JWTURI: API_ENDPOINTS.JWTURI.STAGE,
  AUTHORITY: API_ENDPOINTS.AUTHORIZATION_ENDPOINT.STAGE,
  CLIENT_ID: API_ENDPOINTS.CLIENT_ID.STAGE,
  CONSUMER_PREVIEW_ENDPOINT: API_ENDPOINTS.CONSUMER_PREVIEW_ENDPOINT.STAGE,
  MST_BASE_SERVICE_URL: API_ENDPOINTS.MST_BASE_SERVICE_URL.STAGE,
  DG_BASE_SERVICE_URL: API_ENDPOINTS.DG_BASE_SERVICE_URL.STAGE,
  SOCKET_ENDPOINT: API_ENDPOINTS.SOCKET_ENDPOINT.STAGE,
  VSPEC_GUEST_PORTAL: API_ENDPOINTS.VSPEC_GUEST_PORTAL.STAGE,
  CREDIT_APP_URL: API_ENDPOINTS.CREDIT_APP_URL.STAGE,
  ENGAGE_MATERIAL_URL: API_ENDPOINTS.ENGAGE_MATERIAL_URL.STAGE,
  ENGAGE_MATERIAL_LEXUS_URL: API_ENDPOINTS.ENGAGE_MATERIAL_LEXUS_URL.STAGE,
  MST_CONSOLE: API_ENDPOINTS.MST_CONSOLE.STAGE,
  AUTH_AUTHORITY: API_ENDPOINTS.AUTH_AUTHORITY.STAGE,
  FEATURE_FLAGS: featureFlags,
  SIGNAL_URL: API_ENDPOINTS.SIGNAL.STAGE,
  TRADE_SIGNAL_URL: API_ENDPOINTS.TRADE_SIGNAL_ENDPOINT.STAGE
};

export const environment = defaultsDeep(override, environmentDefaults);
